import Footer from "./footer";
import NavBar from "./NavBar";
import Transaction from "./Transaction";

import React, { useState, useEffect } from 'react';
import transactionsData from './data/transactions.json'; // Assuming you have a JSON file with transaction data


function Pay
    () {

    // const getRandomTransaction = () => {
    //     const types = ['Commission', 'Bonus', 'Refund', 'Sale'];
    //     const type = types[Math.floor(Math.random() * types.length)];
    //     const amount = `€${(Math.random() * (7500 - 2500) + 2500).toFixed(2)}`;
    //     const dateObj = new Date(Date.now() - Math.random() * 100000000);
    //     const date = `${dateObj.toLocaleString('en-US', { month: 'long' })} ${dateObj.getDate()} ${dateObj.getFullYear()}`;

    //     return { date, type, amount };
    // };
    // const generateTransactions = () =>
    //     Array.from({ length: 16 }, () => getRandomTransaction());

    // const [transactions, setTransactions] = useState(generateTransactions);
    const currentYear = new Date().getFullYear();
    const [transactions, setTransactions] = useState([]);
    const [filteredMonth, setFilteredMonth] = useState(null);

    // const [reloadB, setReloadB] = useState('All Time');
    // const refreshTransactions = () => {
    //     setTransactions(generateTransactions());
    // };

    // const handleReload = (monthh) => {
    //     setReloadB(monthh);
    // };
    const handleHide = () => {
        sethidesolda(prev => !prev);
    };
    // useEffect(() => {
    //     refreshTransactions();
    // }, [reloadB]);
    useEffect(() => {
        setTransactions(transactionsData);
    }, []);
    const handleFilter = (monthh) => {
        monthh === 'All Time' ? setFilteredMonth(null) : setFilteredMonth(monthh);
    };

    const getFilteredTransactions = () => {
        if (!filteredMonth) return transactions;
        return transactions.filter(t => t.date.startsWith(filteredMonth) && t.date.endsWith(currentYear));
    };

    const [hidesolda, sethidesolda] = useState(false);
    return (
        <div className="w-screen ltr-direction">
            {/* Fixed Navbar */}

            <NavBar onClickDiv={handleFilter} hidesolda={handleHide} />


            {/* Scrollable middle section */}
            <div className="body w-screen  flex-1 mt-1 mb-6 overflow-y-auto">
                {getFilteredTransactions().map((transaction, index) => (
                    <Transaction key={index} transaction={transaction} hide={hidesolda} />
                ))}
            </div>

            {/* Fixed Footer */}

            <Footer />

        </div>
    );

}
export default Pay;